// usePageViewTracker — best-effort tracking of route changes + product views
// Uses localStorage for stable visitor_id + session_id (30 min sliding window).
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/providers";

function ensureVisitorToken() {
  try {
    let t = localStorage.getItem("dzts_visitor_id");
    if (!t) { t = crypto.randomUUID(); localStorage.setItem("dzts_visitor_id", t); }
    return t;
  } catch { return ""; }
}

function ensureSessionId() {
  try {
    const raw = localStorage.getItem("dzts_session");
    const now = Date.now();
    if (raw) {
      const [sid, expIso] = raw.split("|");
      if (sid && expIso && Number(expIso) > now) {
        // Slide session by 30 min on activity
        localStorage.setItem("dzts_session", `${sid}|${now + 30 * 60 * 1000}`);
        return sid;
      }
    }
    const sid = crypto.randomUUID();
    localStorage.setItem("dzts_session", `${sid}|${now + 30 * 60 * 1000}`);
    return sid;
  } catch { return ""; }
}

export function useTrackPageView() {
  const location = useLocation();
  const params = useParams();
  useEffect(() => {
    // Skip admin routes to avoid polluting analytics
    if ((location.pathname || "").startsWith("/dz-control-2026")) return undefined;
    const payload = {
      path: location.pathname + (location.search || ""),
      product_id: params?.id || null,   // /produit/:id
      title: document.title || "",
      visitor_token: ensureVisitorToken(),
      session_id: ensureSessionId(),
      referrer: document.referrer || "",
      lang: (document.documentElement.lang || "fr").slice(0, 2),
    };
    // Fire and forget
    axios.post(`${API}/track/pageview`, payload).catch(() => {});
    return undefined;
  }, [location.pathname, location.search, params?.id]);
}
